<!-- main app container -->
<div class="card m-3">
  <h5 class="card-header text-center">Angular 14 Reactive Forms Validation</h5>
  <div class="card-body">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col mb-3">
          <label class="form-label">Title</label>
          <select formControlName="title" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
            <option value=""></option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Miss">Miss</option>
            <option value="Ms">Ms</option>
          </select>
          @if (submitted && f.title.errors) {
            <div class="invalid-feedback">
              @if (f.title.errors.required) {
                <div>Title is required</div>
              }
            </div>
          }
        </div>
        <div class="col-5 mb-3">
          <label class="form-label">First Name</label>
          <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
          @if (submitted && f.firstName.errors) {
            <div class="invalid-feedback">
              @if (f.firstName.errors.required) {
                <div>First Name is required</div>
              }
            </div>
          }
        </div>
        <div class="col-5 mb-3">
          <label class="form-label">Last Name</label>
          <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
          @if (submitted && f.lastName.errors) {
            <div class="invalid-feedback">
              @if (f.lastName.errors.required) {
                <div>Last Name is required</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label class="form-label">Date of Birth</label>
          <input type="date" formControlName="dob" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" />
          @if (submitted && f.dob.errors) {
            <div class="invalid-feedback">
              @if (f.dob.errors.required) {
                <div>Date of Birth is required</div>
              }
              @if (f.dob.errors.pattern) {
                <div>Date of Birth must be a valid date in the format YYYY-MM-DD</div>
              }
            </div>
          }
        </div>
        <div class="col mb-3">
          <label class="form-label">Email</label>
          <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
          @if (submitted && f.email.errors) {
            <div class="invalid-feedback">
              @if (f.email.errors.required) {
                <div>Email is required</div>
              }
              @if (f.email.errors.email) {
                <div>Email must be a valid email address</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label class="form-label">Password</label>
          <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
          @if (submitted && f.password.errors) {
            <div class="invalid-feedback">
              @if (f.password.errors.required) {
                <div>Password is required</div>
              }
              @if (f.password.errors.minlength) {
                <div>Password must be at least 6 characters</div>
              }
            </div>
          }
        </div>
        <div class="col mb-3">
          <label class="form-label">Confirm Password</label>
          <input type="password" formControlName="confirmPassword" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
          @if (submitted && f.confirmPassword.errors) {
            <div class="invalid-feedback">
              @if (f.confirmPassword.errors.required) {
                <div>Confirm Password is required</div>
              }
              @if (f.confirmPassword.errors.mustMatch) {
                <div>Passwords must match</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-check mb-3">
        <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }" />
        <label for="acceptTerms" class="form-check-label">Accept Terms & Conditions</label>
        @if (submitted && f.acceptTerms.errors) {
          <div class="invalid-feedback">Accept Ts & Cs is required</div>
        }
      </div>
      <div class="text-center">
        <button class="btn btn-primary me-2">Register</button>
        <button class="btn btn-secondary" type="reset" (click)="onReset()">Cancel</button>
      </div>
    </form>
  </div>
</div>

<!-- credits -->
<div class="text-center">
  <p>
    <a href="https://jasonwatmore.com/post/2022/11/18/angular-14-reactive-forms-validation-example" target="_blank">Angular 14 - Reactive Forms Validation Example</a>
    |
    <a href="https://jasonwatmore.es/post/2022/11/18/angular-14-ejemplo-de-validacion-de-formularios-reactivos-reactive-forms" target="_blank">en Español</a>
  </p>
  <p>
    <a href="https://jasonwatmore.com" target="_top">JasonWatmore.com</a>
  </p>
</div>